import React, { useState } from "react";
import ProfileSidebar from "./ProfileSidebar";
import ProfileInfo from "./Profileinfo";
import MyAddress from "./Myaddress";
import Notifications from "./notifications";
import ReferPage from "../../Components/Referafrnd";
import ReferralRewards from "../../Components/ReferRewards";

const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState("profile");

  return (
    <div className="container" style={{marginTop:"115px"}}>
      <div className="row">
        {/* Left Sidebar */}
        <div className="col-md-3">
          <ProfileSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>

        {/* Right Content */}
        <div className="col-md-9">
          {activeTab === "profile" && <ProfileInfo />}
          {activeTab === "address" && <MyAddress />}
          {activeTab === "referrewards" && <ReferralRewards />}
          {activeTab === "review&ratings" && <ProfileInfo />}
          {activeTab === "notifications" && <Notifications />}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
